"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilterOptions = void 0;
var _react = require("react");
var _SearchExp = require("../../helpers/SearchExp");
var _SearchMulti = require("../../helpers/SearchMulti");
var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};
function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
var useFilterOptions = exports.useFilterOptions = function useFilterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$ignoreAccents = config.ignoreAccents,
    ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
    _config$ignoreCase = config.ignoreCase,
    ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
    limit = config.limit,
    _config$matchFrom = config.matchFrom,
    matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
    _config$stringify = config.stringify,
    stringify = _config$stringify === void 0 ? defaultStringify : _config$stringify,
    _config$trim = config.trim,
    trim = _config$trim === void 0 ? false : _config$trim,
    _config$searchExp = config.searchExp,
    searchExp = _config$searchExp === void 0 ? false : _config$searchExp,
    _config$multiple = config.multiple,
    multiple = _config$multiple === void 0 ? false : _config$multiple,
    _config$enabled = config.enabled,
    enabled = _config$enabled === void 0 ? true : _config$enabled;
  return (0, _react.useCallback)(function (options, _ref) {
    var inputValue = _ref.inputValue;
    if (!enabled) {
      return options;
    }
    var input = trim ? inputValue.trim() : inputValue;
    if (ignoreCase) {
      input = input.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
    }
    if (searchExp) {
      try {
        input = new _SearchExp.SearchExp(input);
      } catch (e) {}
    } else if (multiple) {
      try {
        input = new _SearchMulti.SearchMulti(input);
      } catch (e) {}
    }
    var filteredOptions = options.map(function (option) {
      var candidate = stringify(option);
      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }
      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }
      var match = false;
      if (input instanceof _SearchExp.SearchExp || input instanceof _SearchMulti.SearchMulti) {
        match = input.match(candidate);
      } else {
        match = matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
      }

      // use map to keep initial indexes
      return match ? option : undefined;
    });
    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  }, [ignoreAccents, ignoreCase, limit, matchFrom, stringify, trim, searchExp, enabled]);
};